function buildPdpMobileDisclaimerCss() {
  return `
    @media (max-width: 767px) {
      #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] {
        justify-content: center !important;
        align-items: center;
        padding: 12px 50px;
        min-height: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        box-sizing: border-box;
      }
      #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div {
        max-width: 100%;
        width: 100%;
        margin-inline: auto;
      }
      #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:first-child {
        padding-bottom: 14px;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] {
        gap: 12px;
        align-items: center;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] > div {
        gap: 12px !important;
        align-items: center;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] img,
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] svg,
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] [class*="icon"] {
        height: 100px !important;
        max-height: 100px !important;
        width: auto !important;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] p {
        font-size: 12px !important;
        line-height: 1.4 !important;
        max-width: 100% !important;
        text-align: center;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-disclaimer-terms-policy"] {
        padding-top: 14px;
        font-size: 12px;
        line-height: 1.4;
        text-align: center;
      }
      #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:last-child > div:last-child {
        padding: 12px 0 0 !important;
      }
      #vtoAdvDisclaimerBtnAgree {
        font-size: 13px !important;
        padding: 11px 12px !important;
        min-height: 42px;
      }
      #vtoAdvDisclaimer.disclaimer-policy-open [data-style="vto-adv-disclaimer-explanation"],
      #vtoAdvDisclaimer.disclaimer-policy-open vto-advanced-disclaimer-explanation {
        max-height: 40vh;
        font-size: 12px;
      }
    }
  `;
}

function htmlToPlainText(html) {
  if (!html || typeof html !== 'string') return '';
  const el = document.createElement('div');
  el.innerHTML = html;
  return (el.textContent || '').trim();
}

function escapeCssContent(value) {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
    .replace(/\r/g, '')
    .replace(/\n/g, '\\A ');
}

function buildDisclaimerCopyCss() {
  const shortText = window.tryOnDisclaimerShortText?.trim();
  const activateLong = window.tryOnDisclaimerActivateLong?.trim();
  let css = '';

  if (shortText) {
    const intro = escapeCssContent(htmlToPlainText(shortText));
    css += `
      [data-style="vto-adv-introduction"] p {
        font-size: 0 !important;
        line-height: 0 !important;
        color: transparent !important;
      }
      [data-style="vto-adv-introduction"] p * {
        display: none !important;
      }
      [data-style="vto-adv-introduction"] p::after {
        content: "${intro}";
        font-size: 14px;
        line-height: 1.5;
        color: #232325;
        display: block;
        white-space: normal;
        text-align: center;
        max-width: 400px;
        margin-inline: auto;
      }
    `;
  }

  if (activateLong) {
    const policyLine = escapeCssContent(activateLong);
    css += `
      [data-style="vto-adv-disclaimer-terms-policy"] {
        position: relative;
        cursor: pointer;
        font-size: 0 !important;
        line-height: 0 !important;
        color: transparent !important;
      }
      [data-style="vto-adv-disclaimer-terms-policy"] p {
        margin: 0;
      }
      [data-style="vto-adv-disclaimer-terms-policy"] [data-testid="dialog-button"] {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        opacity: 0 !important;
        cursor: pointer !important;
        font-size: 14px !important;
        text-decoration: none !important;
      }
      [data-style="vto-adv-disclaimer-terms-policy"]::after {
        content: "${policyLine}";
        font-size: 14px;
        line-height: 1.5;
        color: rgb(35, 35, 37);
        display: block;
        white-space: normal;
        text-align: center;
        pointer-events: none;
      }
    `;
  }

  return css;
}

export function buildFitmixDisclaimerCss({ compactMobile = false } = {}) {
  const regularUrl = window.tryOnFontGothicRegular || '';
  const mediumUrl = window.tryOnFontGothicMedium || '';
  const bodyFont = regularUrl ? "'GothicA1-Regular', sans-serif" : 'sans-serif';
  const mediumFont = mediumUrl ? "'GothicA1-Medium', sans-serif" : 'sans-serif';

  const fontFaces =
    regularUrl && mediumUrl
      ? `
    @font-face {
      font-family: 'GothicA1-Regular';
      src: url('${regularUrl}') format('woff2');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'GothicA1-Medium';
      src: url('${mediumUrl}') format('woff2');
      font-weight: 500;
      font-style: normal;
      font-display: swap;
    }
  `
      : '';

  return `
    ${fontFaces}
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] {
      display: flex;
      flex-direction: column !important;
      justify-content: center;
      align-items: center;
      height: 100%;
      min-height: 100%;
      padding: 0 50px;
      box-sizing: border-box;
      font-family: ${bodyFont};
      background: #FFF;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div {
      flex: 0 0 auto;
      width: 100%;
      max-width: 386px;
      background: #FFF;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:first-child {
      display: flex !important;
      padding-bottom:30px;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:last-child {
      display: flex;
      flex-direction: column;
      flex: 0 0 auto;
      justify-content: flex-start;
      height: auto;
      overflow: visible;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:last-child > div:first-child {
      margin-top: 0 !important;
      width: 100%;
      padding:0;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:last-child > div:last-child {
      position: relative !important;
      right: auto !important;
      bottom: auto !important;
      box-shadow: none !important;
      padding: 18px 0 0 !important;
      width: 100%;
      background: #FFF;
    }
    #vtoAdvDisclaimerBtnDisagree { display: none; }
    [data-style="vto-adv-disclaimer-explanation"],
    vto-advanced-disclaimer-explanation {
      display: none !important;
      font-family: ${bodyFont};
      font-size: 14px;
      line-height: 1.5;
      max-height: 60vh;
      overflow-y: auto;
    }
    #vtoAdvDisclaimer.disclaimer-policy-open [data-style="vto-adv-disclaimer-explanation"],
    #vtoAdvDisclaimer.disclaimer-policy-open vto-advanced-disclaimer-explanation {
      display: block !important;
    }
    [data-style="vto-adv-introduction"] {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 18px;
      height: auto !important;
      font-family: ${bodyFont};
    }
    [data-style="vto-adv-introduction"] > div {
      gap: 18px !important;
    }
    [data-style="vto-adv-introduction"] p {
      max-width: 400px !important;
      width: 100%;
    }
    [data-style="vto-adv-disclaimer-terms-policy"] {
      width: 100%;
      border-top: 1px solid #D0D0D0;
      padding-top: 30px;
      font-family: ${bodyFont};
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
    }
    [data-style="vto-adv-disclaimer-actions"] {
      width: 100%;
    }
    #vtoAdvDisclaimerBtnAgree {
      width: 100%;
      background-color: #004AC7 !important;
      color: #FFF !important;
      font-family: ${mediumFont};
      font-size: 14px;
      font-weight: 500;
    }
    ${buildDisclaimerCopyCss()}
    ${compactMobile ? buildPdpMobileDisclaimerCss() : ''}
  `;
}

function syncDisclaimerExplanationVisibility() {
  const root = document.getElementById('vtoAdvDisclaimer');
  if (!root) return;

  const show = root.classList.contains('disclaimer-policy-open');
  root
    .querySelectorAll('[data-style="vto-adv-disclaimer-explanation"], vto-advanced-disclaimer-explanation')
    .forEach((el) => {
      el.style.display = show ? '' : 'none';
    });
}

function setupDisclaimerPolicyClick() {
  if (window.__luxDisclaimerPolicyClick) return;
  window.__luxDisclaimerPolicyClick = true;

  document.addEventListener(
    'click',
    (e) => {
      const root = document.getElementById('vtoAdvDisclaimer');
      if (!root?.contains(e.target)) return;

      if (!e.target.closest('[data-style="vto-adv-disclaimer-terms-policy"]')) return;

      root.classList.add('disclaimer-policy-open');
      syncDisclaimerExplanationVisibility();
    },
    true
  );
}

/**
 * @param {Record<string, unknown>} params FitMix widget params
 * @param {{ container?: Element, compactMobile?: boolean }} [options]
 */
export function applyFitmixDisclaimerParams(params, { container, compactMobile = false } = {}) {
  setupDisclaimerPolicyClick();
  params.css = buildFitmixDisclaimerCss({ compactMobile });

  const longText = window.tryOnDisclaimerLongText?.trim();
  const agreeButton = window.tryOnDisclaimerAgreeButton;
  const disagreeButton = window.tryOnDisclaimerDisagreeButton;

  if (longText || agreeButton || disagreeButton) {
    params.dataPrivacyDisclaimerTexts = {};

    if (longText) {
      params.dataPrivacyDisclaimerTexts.longText = longText;
    }
    if (agreeButton) {
      params.dataPrivacyDisclaimerTexts.agreeButton = agreeButton;
    }
    if (disagreeButton) {
      params.dataPrivacyDisclaimerTexts.disagreeButton = disagreeButton;
    }
  }

  const onPrivacyTermsShown = () => {
    container?.classList.add('disclaimer-shown');
  };

  const closeDisclaimer = () => {
    container?.classList.remove('disclaimer-shown');
    document.getElementById('vtoAdvDisclaimer')?.classList.remove('disclaimer-policy-open');
    syncDisclaimerExplanationVisibility();
  };

  const onAgreePrivacyTerms = closeDisclaimer;

  const onDisagreePrivacyTerms = closeDisclaimer;

  params.onPrivacyTermsShown = onPrivacyTermsShown;
  params.onAgreePrivacyTerms = onAgreePrivacyTerms;
  params.onDisagreePrivacyTerms = onDisagreePrivacyTerms;
}
